// const apiBaseUrl = "https://aaopenplatform.accessaccelerated.org/aaop_server_uat/"; // UAT
const apiBaseUrl = "https://aaopenplatform.accessaccelerated.org/aaop_server/"; // LIVE
// const apiBaseUrl = "http://localhost:3001/"; // Local host

export default apiBaseUrl;
